class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.restoreSearchText();
      this.input.form.addEventListener('formdata', this.onStrictSearchSubmit.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  buildSearchQuery(value) {
    const query = value
      .replace(/\b(?:title|body|tag|variants\.sku|sku):/gi, '')
      .replace(/\b(?:AND|OR)\b/gi, ' ')
      .replace(/[()]/g, ' ')
      .replace(/\*/g, ' ')
      .replace(/["“”]/g, ' ')
      .trim();

    const isSku = /^[a-z0-9]+$/i.test(query) && /[a-z]/i.test(query) && /\d/.test(query);

    if (isSku) {
      return `variants.sku:${query}*`;
    }

    const terms = query.split(/\s+/).filter(Boolean);
    return terms.map((term) => `(title:${term}* OR body:${term}* OR tag:${term}*)`).join(' ');
  }

  restoreSearchText() {
    if (new URL(this.input.form.action, window.location.href).pathname !== window.location.pathname) return;
    const query = new URLSearchParams(window.location.search).get('q');
    if (!query) return;

    let text = this.getSearchText(query);
    try {
      const saved = JSON.parse(sessionStorage.getItem('tvj-search-text'));
      if (saved && saved.query === query && this.buildSearchQuery(saved.text) === query) {
        text = saved.text;
      }
    } catch (error) {
      // Search still works when browser storage is unavailable.
    }
    this.input.value = text;
    this.input.defaultValue = text;
  }

  getSearchText(query) {
    const sku = query.match(/^variants\.sku:([a-z0-9]+)\*$/i);
    if (sku) return sku[1];

    // Decode only the exact groups generated by our search rules.
    // Keep repeated customer words; do not deduplicate all query tokens.
    const group = /\((?:title:)?([^\s()*]+)\*? OR body:\1\*? OR tag:\1\*?\)/g;
    const terms = [];
    const remainder = query.replace(group, (match, term) => {
      terms.push(term);
      return '';
    });
    return terms.length && !remainder.trim() ? terms.join(' ') : query;
  }

  onStrictSearchSubmit(event) {
    const text = this.input.value;
    const query = this.buildSearchQuery(text);
    // Change the submitted data, leaving the editable field untouched.
    event.formData.set('q', query);
    try {
      sessionStorage.setItem('tvj-search-text', JSON.stringify({ query, text }));
    } catch (error) {
      // The URL can reconstruct the words without browser storage.
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
